import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { observer } from 'mobx-react-lite'
import { CloseButton } from 'page/StandHeader/CloseButton'
import { OutfitsHeader } from 'page/StandHeader/header/OutfitsHeader'
import { ProfileHeader } from 'page/StandHeader/header/ProfileHeader'
import { ReactElement, useEffect, useRef } from 'react'
import { stand } from 'store/stand'
import { store } from 'store/store'
import css from './StandHeader.module.scss'

function header(): ReactElement | undefined {
  switch (store.screen) {
    case 'profile':
      return <ProfileHeader />
    case 'image':
      return <OutfitsHeader />
    case 'generations':
      return <OutfitsHeader />
    default:
      return undefined
  }
}

export const StandHeader = observer(() => {
  const ref = useRef<HTMLDivElement>(null)
  const className = clsx(css.header, stand.compact && css.shadow)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const update = () => {
      stand.header = element.offsetHeight
    }

    const observer = new ResizeObserver(update)
    observer.observe(element)
    update()

    return () => {
      observer.disconnect()
      stand.header = 0
    }
  }, [])

  return <Space className={className}>
    <Space ref={ref} className={css.inner}>
      {header()}
    </Space>
    <CloseButton />
  </Space>
})
